import { render, staticRenderFns } from "./FormEditRating.vue?vue&type=template&id=27412c80&scoped=true&"
import script from "./FormEditRating.vue?vue&type=script&lang=js&"
export * from "./FormEditRating.vue?vue&type=script&lang=js&"
import style0 from "./FormEditRating.vue?vue&type=style&index=0&id=27412c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27412c80",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RatingStars: require('/home/circleci/repo/components/RatingStars.vue').default})
